import React from "react"
import classnames from "classnames"
import styles from "./Alert.less"
import { AlertIcon, Caption } from "AtomicComponents"

class Alert extends React.PureComponent {
  render() {
    const { children, styleName = "red" } = this.props
    return (
      <div
        className={classnames({
          [styles.Alert]: true,
          [styles.AlertRed]: styleName === "red"
        })}>
        <AlertIcon style={{
          width: "16px",
          height: "16px",
          margin: "2px 12px 0 0",
          flexShrink: 0
        }} />
        <Caption>{children}</Caption>
      </div>
    )
  }
}


export default Alert



// WEBPACK FOOTER //
// ./src/AtomicComponents/Alert/Alert.jsx